export const BleConfig = {
  maxPacketLengthWithoutOffset: 19,
  services: {
    upgrade: {
      service: '9e5d1e47-5c13-43a0-8635-82ad38a1386f',
      charac: '347f7608-2e2d-47eb-913b-75d4edc4de3b',
    },
    lwm2m: {
      // // SPP over BLE Service UUID (128-bit)
      service: '6c7b16c2-2a5b-8c9f-cf42-d31425470e7b', // 6c7b16c22a5b8c9fcf42d31425470e7b
      charac: 'cc5c5491-b3be-9287-cb42-f7a6a29a50d5',
    },
    fastLwm2m: {
      service: '7c7b16c2-2a5b-8c9f-cf42-d31425470e7b',
      charac: 'dc5c5491-b3be-9287-cb42-f7a6a29a50d5',
    },
    standardClientConfig: {
      service: '00002902-0000-1000-8000-00805f9b34fb',
    },
  },
};
